import { Block as BlockSDS } from '@snapchat/snap-design-system-marketing';
import type { FC } from 'react';

import { CallToAction } from '../../../../components/CallToAction';
import type { ContentfulIdVariable } from '../../../../hooks/useContentfulQuery';
import { useContentfulQuery } from '../../../../hooks/useContentfulQuery';
import type { ContentfulIdProps } from '../../../../types/contentful';
import { getContrastColor } from '../../helpers/getContrastColor';
import { ArDownloadLinkCard } from '../ArDownloadLinkCard/ArDownloadLinkCard';
import { arLinkOutsBlockCss, createCtaContainerCss } from './ArLinkOutsBlock.styles';
import type { ArLinkOutsBlockQuery } from './arLinkOutsBlockQuery';
import { query } from './arLinkOutsBlockQuery';

type ArLinkOutsBlockProps = ContentfulIdProps & {
  id: string;
};

export const ArLinkOutsBlock: FC<ArLinkOutsBlockProps> = ({ id }) => {
  const { data } = useContentfulQuery<ArLinkOutsBlockQuery, ContentfulIdVariable>(query, {
    variables: { id },
  });

  if (!data?.arLinkOutsBlock) {
    return null;
  }

  const { backgroundColor, ctaColor, linksCollection, callsToActionCollection } =
    data.arLinkOutsBlock;

  const links = linksCollection?.items || [];
  const callsToAction = callsToActionCollection?.items || [];

  if (links.length === 0 && callsToAction.length === 0) {
    return null;
  }

  const bgColor = backgroundColor || '#000000FF';
  const ctaTextColor = ctaColor ? getContrastColor(ctaColor) : undefined;
  const ctaContainerCss = createCtaContainerCss(ctaColor, ctaTextColor);

  return (
    <BlockSDS
      className={arLinkOutsBlockCss}
      style={{ '--custom-bg-color': bgColor } as React.CSSProperties}
    >
      {links.map(link => (
        <ArDownloadLinkCard key={link.sys.id} id={link.sys.id} />
      ))}
      {callsToAction.length > 0 && (
        <div className={ctaContainerCss}>
          {callsToAction.map(cta => (
            <CallToAction key={cta.sys.id} {...cta} />
          ))}
        </div>
      )}
    </BlockSDS>
  );
};
